import { useNavigate } from 'react-router-dom';
import Success from '~/components/Success/Success';
import SuccessImage from '~/assets/img/completion_images/girls_smiling_and_waving.png';

type ReportSuccessProps = {
  onClickConfirm: () => void;
};

export default function ReportSuccess({ onClickConfirm }: ReportSuccessProps) {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (onClickConfirm) {
      onClickConfirm();
    } else {
      navigate(-1);
    }
  };

  return (
    <Success
      image={SuccessImage}
      title={'Thank you for your feedback!'}
      subTitle={`We've successfully received your input, and it's greatly valued as we strive to improve our services.`}
      buttonTitle='Okay'
      onClick={handleOnClick}
    />
  );
}
